<template>
  <v-container fluid grid-list-lg>
    <v-card>
      <v-toolbar>
        <v-icon>ballot</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Actualización Base Prefijos</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)">
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text>
        <v-row align="center" dense>
          <v-col>
            <v-file-input
              v-model="archivosASubir"
              accept=".xlsx, .xls"
              dense
              placeholder="Seleccione el Archivo a Procesar"
              label="Archivo a Procesar"
              counter
              show-size
              prepend-icon="mdi-paperclip">
            </v-file-input>
          </v-col>
          <v-col cols="2"> </v-col>

          <v-col cols="4" lg="2" v-if="archivosASubir">
            <v-btn
              :disabled="loading"
              text
              class="black--text green"
              @click="ProcesarArchivo"
              small>
              Procesar &nbsp;
              <v-progress-circular
                v-if="loading"
                indeterminate
                size="20"></v-progress-circular>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- process progress -->

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{}}
      <p></p>
    </template>
    <v-divider></v-divider>
  </v-container>
</template>

<script>

import { http } from "@/axios";
import Vue from "vue";
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from "vuex";

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      suspend: false,
      search: "", // valor para búsqueda
      records: [], // registros
      totalItemsLog: 0,
      optionsLog: {
        // definición de paginación
        sortDesc: [true],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems: [5, 10, 20],
      },
      archivosASubir: null,
    };
  },

  watch: {},

  computed: {
    ...mapGetters([
      "getActionFromLink",
      "error",
      "user",
      "ParametrosGenerales",
    ]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
  },
  methods: {
    ...mapMutations([
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
      "setReporteActivo",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),

    async ProcesarArchivo() {
      if (!this.archivosASubir) {
        this.alertWarning("Debe seleccionar un archivo.");
        this.loading = false;
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("excelFile", this.archivosASubir);

      try {
        var result = await http.post(
          "fileprocessing/actualizarbaseprefijos",
          formData
        );

        this.alertSuccess(
          `Se procesaron ${result.casosExitosos.length} casos con éxito y fallaron ${result.casosFallidos.length} casos.`
        );
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    }
  },
};
</script>
